import { IRoutesDefined } from "@/api_framework/api_modals/Routers";

export const CART_MANAGEMENT_SUB_NAV_ROUTES: IRoutesDefined = {
  CART_LIST: {
    id: "CART_LIST",
    title: "cart list",
    RBACDescription: "Access to view order management dashboard.",
    RBACDisplayName: "CART LIST",
    icon: "BsCardChecklist",
    path: "cart-list",
    url: "/app/user-cart/cart-list",
    isVirtual: true,
    children: {},
  },
  HD_CART_CTA: {
    id: "HD_CART_CTA",
    title: "hd cart",
    RBACDescription: "Access to hd cart",
    RBACDisplayName: "HD_CART_BUTTON_CTA",
    icon: "BsCardChecklist",
    path: "cta-action-hd-cart",
    url: "/app/hd-cart/cta-action-hd-cart",
    isVirtual: true,
    children: {},
  },
  HD_CART_PAGE: {
    id: "HD_CART_PAGE",
    title: "cart page",
    RBACDescription: "Access to view cart page.",
    RBACDisplayName: "HD Cart Page",
    icon: "BsCardChecklist",
    path: "hd-cart",
    url: "/app/user-cart/hd-cart",
    isVirtual: true,
    children: {},
  },
  INVOICE_LIST: {
    id: "INVOICE_LIST",
    title: "invoice list",
    RBACDescription: "Access to invoice list",
    RBACDisplayName: "INVOICE LIST",
    icon: "BsCardChecklist",
    path: "invoice-list",
    url: "/app/user-cart/invoice-list",
    isVirtual: true,
    children: {},
  },
  REFUND_INVOICE_ACTION_CTA: {
    id: "REFUND_INVOICE_ACTION_CTA",
    title: "invoice list",
    RBACDescription: "Access to invoice list",
    RBACDisplayName: "REFUND_INVOICE_ACTION_BUTTON_CTA",
    icon: "BsCardChecklist",
    path: "invoice-list",
    url: "/app/user-cart/invoice-list/cta-action",
    isVirtual: true,
    children: {},
  },
  RETURN_INVOICE_ACTION_CTA: {
    id: "RETURN_INVOICE_ACTION_CTA",
    title: "invoice list",
    RBACDescription: "Access to invoice list",
    RBACDisplayName: "RETURN_INVOICE_ACTION_BUTTON_CTA",
    icon: "BsCardChecklist",
    path: "invoice-list",
    url: "/app/user-cart/invoice-list/cta-action-r",
    isVirtual: true,
    children: {},
  },
  CANCEL_INVOICE_ACTION_CTA: {
    id: "CANCEL_INVOICE_ACTION_CTA",
    title: "invoice list",
    RBACDescription: "Access to invoice list",
    RBACDisplayName: "CANCEL_INVOICE_ACTION_BUTTON_CTA",
    icon: "BsCardChecklist",
    path: "invoice-list",
    url: "/app/user-cart/invoice-list/cta-action-c",
    isVirtual: true,
    children: {},
  },
  REMOVE_MEMBERSHIP_ACTION_CTA: {
    id: "REMOVE_MEMBERSHIP_ACTION_CTA",
    title: "invoice list",
    RBACDescription: "Remove memberships from an invoice whose Snapmint EMI was not completed",
    RBACDisplayName: "REMOVE_MEMBERSHIP_ACTION_BUTTON_CTA",
    icon: "BsCardChecklist",
    path: "invoice-list",
    url: "/app/user-cart/invoice-list/cta-action-rm",
    isVirtual: true,
    children: {},
  },
  VIEW_INVOICE_ACTION_CTA: {
    id: "VIEW_INVOICE_ACTION_CTA",
    title: "invoice list",
    RBACDescription: "Access to invoice list",
    RBACDisplayName: "VIEW_INVOICE_ACTION_BUTTON_CTA",
    icon: "BsCardChecklist",
    path: "invoice-list",
    url: "/app/user-cart/invoice-list/cta-action-v",
    isVirtual: true,
    children: {},
  },
  TRANSACTION_HISTORY: {
    id: "TRANSACTION_HISTORY",
    title: "invoice list",
    RBACDescription: "Access to invoice list",
    RBACDisplayName: "TRANSACTION HISTORY",
    icon: "BsCardChecklist",
    path: "transaction-history",
    url: "/app/user-cart/transaction-history",
    isVirtual: true,
    children: {},
  },
  CREDIT_NOTE: {
    id: "CREDIT_NOTE",
    title: "invoice list",
    RBACDescription: "Access to invoice list",
    RBACDisplayName: "CREDIT NOTE",
    icon: "BsCardChecklist",
    path: "credit-note",
    url: "/app/user-cart/credit-note",
    isVirtual: true,
    children: {},
  },
  CREDIT_NOTE_ACTION_CTA: {
    id: "CREDIT_NOTE_ACTION_CTA",
    title: "invoice list",
    RBACDescription: "Access to credit action",
    RBACDisplayName: "CREDIT_NOTE_ACTION_BUTTON_CTA",
    icon: "BsCardChecklist",
    path: "credit-note",
    url: "/app/user-cart/credit-note/cta-action",
    isVirtual: true,
    children: {},
  },
  DEBIT_NOTE: {
    id: "DEBIT_NOTE",
    title: "invoice list",
    RBACDescription: "Access to invoice list",
    RBACDisplayName: "DEBIT NOTE",
    icon: "BsCardChecklist",
    path: "debit-note",
    url: "/app/user-cart/debit-note",
    isVirtual: true,
    children: {},
  },
  ADD_CREDIT: {
    id: "ADD_CREDIT",
    title: "invoice list",
    RBACDescription: "Access to invoice list",
    RBACDisplayName: "ADD CREDIT",
    icon: "BsCardChecklist",
    path: "add-credit",
    url: "/app/user-cart/add-credit",
    isVirtual: true,
    children: {},
  },
  ADD_CREDIT_ACTION_BUTTON: {
    id: "ADD_CREDIT_ACTION_BUTTON",
    title: "invoice list",
    RBACDescription: "Access to add wallet",
    RBACDisplayName: "ADD_CREDIT_WALLET_ACTION_BUTTON",
    icon: "BsCardChecklist",
    path: "add-credit",
    url: "/app/user-cart/add-credit/cta-action",
    isVirtual: true,
    children: {},
  },
  CREDIT_LIST: {
    id: "CREDIT_LIST",
    title: "credit list",
    RBACDescription: "Access to credit  list",
    RBACDisplayName: "CREDIT LIST",
    icon: "BsCardChecklist",
    path: "credit-list",
    url: "/app/user-cart/credit-list",
    isVirtual: true,
    children: {},
  },
  CART_CREATION: {
    id: "CART_CREATION",
    title: "cart creation",
    RBACDescription: "Access to view order management dashboard.",
    RBACDisplayName: "Cart Creation",
    icon: "BsCardChecklist",
    path: "cart-creation",
    url: "/app/user-cart/cart-creation",
    isVirtual: true,
    children: {},
  },
  CART_CREATION_ACTION_CTA: {
    id: "CART_CREATION_ACTION_CTA",
    title: "cart creation",
    RBACDescription: "Access to cart creation button",
    RBACDisplayName: "CART_CREATION_ACTION_BUTTON_CTA",
    icon: "BsCardChecklist",
    path: "cart-creation",
    url: "/app/user-cart/cart-creation/cta-action",
    isVirtual: true,
    children: {},
  },
  CART_DELETION_ACTION_CTA: {
    id: "CART_DELETION_ACTION_CTA",
    title: "cart creation",
    RBACDescription: "Access to cart creation button",
    RBACDisplayName: "CART_DELETION_ACTION_BUTTON_CTA",
    icon: "BsCardChecklist",
    path: "cart-creation",
    url: "/app/user-cart/cart-creation/cta-action",
    isVirtual: true,
    children: {},
  },
  CART_BILLING: {
    id: "CART_BILLING",
    title: "cart billing",
    RBACDescription: "Access to view order management dashboard.",
    RBACDisplayName: "Cart Billing",
    icon: "BsCardChecklist",
    path: "cart-billing",
    url: "/app/user-cart/cart-billing",
    isVirtual: true,
    children: {},
  },
  CART_BILLING_OFFLINE_PAYMENT: {
    id: "CART_BILLING_OFFLINE_PAYMENT",
    title: "cart billing",
    RBACDescription: "Access to view order management dashboard.",
    RBACDisplayName: "Offline Payment",
    icon: "BsCardChecklist",
    path: "cart-billing-offline",
    url: "/app/user-cart/cart-billing-offline",
    isVirtual: true,
    children: {},
  },

  CART_CREATE_WITHOUT_CLINIC_MAP: {
    id: "CART_CREATE_WITHOUT_CLINIC_MAP",
    title: "cart bypass clinic map",
    path: "cta",
    RBACDisplayName: "CART_CREATE_WITHOUT_CLINIC_MAP",
    RBACDescription: "Create a cart without a matching mapped clinic.",
    url: "/app/cart/create-bypass-clinic-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  CART_ROW_EDIT_ACTION: {
    id: "CART_ROW_EDIT_ACTION",
    title: "cart row edit",
    path: "cta",
    RBACDisplayName: "CART_ROW_EDIT_ACTION",
    RBACDescription: "Row-level edit actions on the pet cart table.",
    url: "/app/cart/row-edit-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  CART_CENTRAL_INVOICE_ACTIONS: {
    id: "CART_CENTRAL_INVOICE_ACTIONS",
    title: "cart central invoice actions",
    path: "cta",
    RBACDisplayName: "CART_CENTRAL_INVOICE_ACTIONS",
    RBACDescription: "Central-only actions on invoices (invoice list / cart billing).",
    url: "/app/cart/central-invoice-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  BILLING_RESTRICTED_PAYMENT_METHODS: {
    id: "BILLING_RESTRICTED_PAYMENT_METHODS",
    title: "billing restricted payments",
    path: "cta",
    RBACDisplayName: "BILLING_RESTRICTED_PAYMENT_METHODS",
    RBACDescription: "Use restricted payment methods (Payu, Razor Pay, Cheque, Blue7Vets Credit, etc.).",
    url: "/app/cart/billing/restricted-payments-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },

  CART_BOOKING_MAPPED_CLINIC_BYPASS: {
    id: "CART_BOOKING_MAPPED_CLINIC_BYPASS",
    title: "cart booking mapped clinic bypass",
    path: "cta",
    RBACDisplayName: "CART_BOOKING_MAPPED_CLINIC_BYPASS",
    RBACDescription:
      "Payment Confirmation — treat any booking as present in mapped clinic (bypass clinic-match check).",
    url: "/app/cart/payment-confirmation-bypass-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  CART_CREATION_CLINIC_MODE: {
    id: "CART_CREATION_CLINIC_MODE",
    title: "cart creation clinic mode",
    path: "cta",
    RBACDisplayName: "CART_CREATION_CLINIC_MODE",
    RBACDescription: "Cart Creation UI runs in clinic-user mode (address flow, barcode scan behavior).",
    url: "/app/cart/creation-clinic-mode-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  CART_CREATION_DOCTOR_MODE: {
    id: "CART_CREATION_DOCTOR_MODE",
    title: "cart creation doctor mode",
    path: "cta",
    RBACDisplayName: "CART_CREATION_DOCTOR_MODE",
    RBACDescription: "Cart Creation — doctor-specific EMR view (navigate to EMR route instead of PDF download).",
    url: "/app/cart/creation-doctor-mode-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  CART_CREATE_FROM_CLINIC: {
    id: "CART_CREATE_FROM_CLINIC",
    title: "cart create from clinic",
    path: "cta",
    RBACDisplayName: "CART_CREATE_FROM_CLINIC",
    RBACDescription: "Clinic-side cart creation entry (Customer Profile default view).",
    url: "/app/cart/create-from-clinic-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  PERSONA_DISCOUNT_COMMENTS_VIEW: {
    id: "PERSONA_DISCOUNT_COMMENTS_VIEW",
    title: "persona discount comments view",
    path: "cta",
    RBACDisplayName: "PERSONA_DISCOUNT_COMMENTS_VIEW",
    RBACDescription: "Show the persona discount comments callout (Cart Creation comments card, Patient Waiting List comment column).",
    url: "/app/cart/persona-discount-comments-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
  HD_ADDRESS_ADD_NEW_RESTRICTED: {
    id: "HD_ADDRESS_ADD_NEW_RESTRICTED",
    title: "hd address add new restricted",
    path: "cta",
    RBACDisplayName: "ALLOW_ADD_NEW_ADDRESS",
    RBACDescription:
      "Restrict this role from adding a new address in the address selection modal (hides the 'Add New Address' tile).",
    url: "/app/cart/hd-address-add-new-restricted-cta",
    icon: "BsDashCircleDotted",
    isVirtual: true,
    children: {},
  },
};
